import React, { lazy } from 'react';
import registry from '~/library/store/src/registry';

const OrderPlacedComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "carvana-order-placed" */ '@carvana/purchase-order-placed'
    ) as unknown as Promise<{ default: React.ComponentType<any> }>
);

export const OrderPlacedRoute = () => {
  return <OrderPlacedComponent registry={registry} />;
};
